// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".spinner[data-v-e1e28966]{border:.15em solid;border-radius:50%;border-right:.15em solid transparent;vertical-align:text-bottom}@keyframes spinner-border-e1e28966{to{transform:rotate(1turn)}}.spinner[data-v-e1e28966]{animation:spinner-border-e1e28966 .75s linear infinite}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
